import { render, staticRenderFns } from "./Priced.vue?vue&type=template&id=63b0b2bb&"
import script from "./Priced.vue?vue&type=script&lang=js&"
export * from "./Priced.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports